// Functions for formatting currency
export const usePriceFormatParts = (price?: number, currencyRate = 1): { integer: string; decimal: string } => {
  if (!price && price !== 0) return { integer: 'N/A', decimal: '' };
  const { currency } = storeToRefs(useCurrencyStore());
  const { locale } = useI18n();
  const parts = new Intl.NumberFormat(locale.value, {
    style: 'currency',
    currency: currency.value,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).formatToParts(price * currencyRate);
  const decimalIndex = parts.findIndex((p) => p.type === 'decimal');
  if (decimalIndex === -1) return { integer: parts.map((p) => p.value).join(''), decimal: '' };
  return {
    integer: parts
      .slice(0, decimalIndex)
      .map((p) => p.value)
      .join('')
      .trimEnd(),
    decimal: parts
      .slice(decimalIndex)
      .map((p) => p.value)
      .join(''),
  };
};

export const usePriceFormat = (
  price?: number,
  currencyRate = 1,
  minimumFractionDigits = 2,
  maximumFractionDigits = 2,
  // For an amount a third party settles in its own currency, whatever the site selector says — Alma,
  // which is euro-only. Leave it out for a price the user pays us: that one follows the selector.
  currencyOverride?: string,
) => {
  if (!price && price !== 0) {
    return 'N/A';
  }
  const currencyStore = useCurrencyStore();
  const { currency } = storeToRefs(currencyStore);
  const { locale } = useI18n();

  return new Intl.NumberFormat(locale.value, {
    style: 'currency',
    currency: currencyOverride ?? currency.value,
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(price * currencyRate);
};
